import React from "react";

function Shop() {
  return (
   <div className="centered-page">
      <h2> Bear Crew Gear</h2>
      <p>
        Here you can find links to both the mandatory uniform shop as well as
        spirit merchandise. JL rowing provides high quality training gear off season, but
        you cannot purchase the offical or required uniforms until spring.
      </p>
      <div style={{ marginBottom: "2.5rem" }}>
        <h2 >
          Crew Jersey or Unisuits via JL Rowing
        </h2>
        <h3 >
          Official Team Shop -  Only Until March 12, 2026!
        </h3>
        <a
          href="https://jlrowing.com/collections/wyandotte-rowing-spring-2026-team-store"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            background: "#162278",
            color: "#fff",
            padding: "1rem 2rem",
            borderRadius: "10px",
            fontWeight: "bold",
            fontSize: "1.1rem",
            textDecoration: "none",
            marginTop: "0.5rem",
            boxShadow: "0 2px 8px rgba(22,22,116,0.10)",
            transition: "background 0.2s, transform 0.2s",
          }}
          onMouseOver={(e) => (e.currentTarget.style.background = "#3a4edc")}
          onMouseOut={(e) => (e.currentTarget.style.background = "#162278")}
        >
          JL Rowing - OFFICAL TEAM SHOP! 
        </a>
        <h3 >
          Additional Spirit Gear Coming Soon! or see us at fundraisers and regattas for the latest gear! 
        </h3>
      </div>

      
    </div>
  );
}

export default Shop;
